<template>
  <div>
    <Head title="Dashboard" />
    <!-- <h1 class="mb-8 text-3xl font-bold">Jarimalarni avtomatlashtirilgan dasturi</h1>
    <p class="mb-8 leading-normal">Jizzaxstat website</p> -->
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
